export default __webpack_public_path__ + "static/media/folder.c71c2c48.png";